<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import RichText from './RichText.vue'

/**
 * A formatted text shown short, whole on a click (an activity's description on the timeline): its
 * first `lines` lines, "Show all" when there is more — so the timeline stays short, as a note
 * written there would not.
 */
const props = defineProps({
  doc: { type: [Object, null], default: null },
  fallback: { type: String, default: '' },
  lines: { type: Number, default: 3 },
})
const box = ref(null)
const open = ref(false)
const more = ref(false)
function measure() {
  const el = box.value
  if (el && !open.value) more.value = el.scrollHeight > el.clientHeight + 2
}
let observer = null
onMounted(() => {
  measure()
  observer = new ResizeObserver(measure)
  if (box.value) observer.observe(box.value)
})
onBeforeUnmount(() => observer?.disconnect())
watch(() => props.doc, () => nextTick(measure))
</script>

<template>
  <div data-testid="clamped-text">
    <div ref="box" :class="['clamped-text', open ? '' : 'overflow-hidden']" :style="open ? null : { maxHeight: `${lines * 1.5}em` }">
      <RichText :doc="doc" :fallback="fallback" />
    </div>
    <button v-if="more || open" type="button" class="link mt-0.5 text-xs" :aria-expanded="open" data-testid="clamped-text-toggle" @click="open = !open">
      {{ open ? $t('common.collapse') : $t('timeline.showAll') }}
    </button>
  </div>
</template>

<style scoped>
.clamped-text { line-height: 1.5; }
</style>
